module.exports = angular.module('cartographer.common.ui.modal', [])

$ = require 'jquery'
_ = require 'underscore'

module.exports.factory 'crtModal', $DI (crtLog, $compile, $controller, $document, $http, $q, $rootScope, $sce, $templateCache, $timeout, crtPromise) ->
  # options -> promise
  #
  # where options are:
  #  - template: string OR
  #  - templateUrl: string
  #  - scope: object
  #  - controller: or(scope -> void, dependencyInjectionArray) (OPTIONAL)
  show = (options) ->
    deferred = $q.defer()

    crtLog.debug('crtModal.show', options)

    if options.templateUrl
      tplPromise = $http.get(options.templateUrl, { cache: $templateCache })
    else
      # Emulate a successful result from $http:
      tplPromise = crtPromise.create({ data: options.template })

    tplPromise.then (tplResult) ->
      { data: template } = tplResult

      crtLog.debug('crtModal.tplPromise.then', template)

      $scope = _.extend($rootScope.$new(), options.scope ? {})

      close = ->
        # Defer the close just in case the constructor calls it right away:
        $timeout ->
          elem.remove()
          $scope.$destroy()
          return
        return

      $scope.modal =
        resolve: (result) ->
          deferred.resolve(result)
          close()
        reject: (reason) ->
          deferred.reject(reason)
          close()

      controller = $controller(
        if typeof options.controller == 'function'
          [ '$scope', options.controller ]
        else
          options.controller || (->)
        _.extend({}, options.locals || {}, { $scope })
      )

      body = $(options.attachTo || document.body).eq(0)
      elem = $compile(template)($scope)
      body.append(elem)

      # Set a scope variable to allow CSS animations to start just after it's shown:
      $timeout ->
        $scope.visible = true
        return

      return deferred.promise

  # or(string, object) -> promiseOf(undefined)
  alert = (options) ->
    crtLog.debug('crtModal.alert', options)
    options = if typeof options == 'string' then { content: options } else options
    options.content = $sce.trustAsHtml(options.content)
    show {
      template    : require './modal-alert.tpl.html'
      controller  : $DI ($scope) ->
        _.extend($scope, {
          title     : 'Alert'
          content   : 'Message goes here...'
          buttons   : options.buttons ? [
            { value : true, label : options.buttonLabel ? 'OK', class : 'btn btn-primary' }
          ]
        }, options)
    }

  error = (message, errorObject) ->
    # TODO: Make these error messages nicer:
    alert {
      title:   "Oops!",
      content: """
               <p>#{message}</p>
               <pre>#{JSON.stringify(errorObject, null, 2)}</pre>
               """
    }

  # or(string, object) -> promiseOf(boolean)
  ask = (options) ->
    crtLog.debug('crtModal.ask', options)
    options = if typeof options == 'string' then { content: options } else options
    options.content = $sce.trustAsHtml(options.content)
    show {
      template    : require './modal-alert.tpl.html'
      controller  : $DI ($scope) ->
        _.extend($scope, {
          title     : 'Question'
          content   : 'Message goes here...'
          buttons   : [
            { value : false, label : options.noLabel  ? 'No',  class : options.noClass  ? 'btn btn-default' }
            { value : true,  label : options.yesLabel ? 'Yes', class : options.yesClass ? 'btn btn-primary' }
          ]
        }, options)
    }

  # or(string, object) -> promiseOf(boolean)
  confirm = (options) ->
    crtLog.debug('crtModal.confirm', options)
    options = if typeof options == 'string' then { content: options } else options
    options.content = $sce.trustAsHtml(options.content)
    show {
      template    : require './modal-alert.tpl.html'
      controller  : $DI ($scope) ->
        _.extend($scope, {
          title     : 'Confirm'
          content   : 'Message goes here...'
          buttons   : [
            { value : false, label : options.cancelLabel ? 'Cancel', class : 'btn btn-default' }
            { value : true,  label : options.okLabel     ? 'OK',     class : 'btn btn-primary' }
          ]
        }, options)
    }

  return {
    show
    alert
    error
    ask
    confirm
  }

module.exports.directive 'crtModal', $DI (crtLog) ->
  return {
    restrict   : 'A'
    template   : require './modal.tpl.html'
    transclude : true
    scope      :
      visible       : '='
      title         : '='
      buttons       : '='
      buttonClicked : '='
      closeClicked  : '='
  }
